// extracted by mini-css-extract-plugin
module.exports = {"code-input":"Form_code-input__qMyBj","input-container":"Form_input-container__7PNzD","textarea-container":"Form_textarea-container__bkBoi","textarea":"Form_textarea__hJ0ix"};